import { useNavigate, useParams } from 'react-router-dom';
import { Typography, Stack, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

HeaderCommon.propTypes = {
    pageType: PropTypes.string.isRequired,
};
export default function HeaderCommon({ pageType }) {
    const navigate = useNavigate();
    const { masterName} = useParams();
    function formatPageName(pageName) {
        const cleanedPageName = pageName ? pageName.trim().replace(/-/g, ' ') : '';
        const formattedPageName = cleanedPageName.replace(/\b\w/g, char => char.toUpperCase());
        return formattedPageName;
    }

    const headerName = formatPageName(masterName);

    const handleClick = () => {
        navigate(-1);
    }
    return (

        <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ bgcolor: pageType === 'add' ? '#20b2aa' : '#3B3C78', height: 40, mb: 2, borderRadius: "8px" }}  >    
            <Stack direction='column' alignItems='flex-start' justifyContent='flex-start' spacing={1}>
                <Typography variant='body1' sx={{ fontSize: '1rem', lineHeight: '0.8rem', color: '#fff' }} style={{ marginLeft: '10px' }} >
                    {headerName}
                </Typography>
            </Stack>
            <Box flexGrow={1} />
            <IconButton onClick={handleClick} sx={{ color: '#fff' }}>
                <CloseIcon sx={{ width: '20px', height: '25px' }} />
            </IconButton>

        </Stack >
    );
}
